import { applicationConfig } from "../../../environmentConfiguration";
import { translationKeys } from "../app-translation-keys";
import { ILanguageOption } from "../interfaces/language-options.interface";
import { defaultRegionMap, LanguageOptionCodes } from "./language-option-codes.const";

// #53348 #57390 Normalize a language entry into language-region form "ll-CC".
// If the input already contains a dash, normalize casing: lang lower, region upper.
// If single-part, look up the default region;
// if none, fallback to uppercased language as region.
function normalizeToCombinedCode(input: string): string {
  const parts = input.split(/[-_]/); // accept "de-at" or "de_at"
  const lang = parts[0].toLowerCase();

  if (parts.length > 1) {
    const region = parts[1].toUpperCase();
    return `${lang}-${region}`;
  }

  const regionFromMap = defaultRegionMap[lang];
  if (regionFromMap) {
    return `${lang}-${regionFromMap}`;
  }

  return `${lang}-${lang.toUpperCase()}`;
}

export type LanguageOptionsEnum = (typeof LanguageOptionCodes)[number];
export type AppLanguageOptionsSubsetEnum = Extract<LanguageOptionsEnum, "de" | "en" | "fr">;

export const AppLanguageOptionsSubset: AppLanguageOptionsSubsetEnum[] = ["de", "en", "fr"];

export const AppLanguageOptions: ILanguageOption[] = AppLanguageOptionsSubset.map(code => ({
  name: code.toUpperCase(),
  labelKey: translationKeys.languages[code],
  code,
}));

export const AllLanguageOptions: ILanguageOption[] = LanguageOptionCodes.map(code => ({
  name: code.toUpperCase(),
  labelKey: translationKeys.languages[code],
  code,
  combinedCode: normalizeToCombinedCode(code),
}));

// In #66946: we specifically implemented filtering the dropdown language options
// based on the enabledDropdownLanguages configuration.
// This was a "quick-fix" solution because otherwise other components would need a larger rework
export const DropdownLanguageOptions: ILanguageOption[] = applicationConfig.enabledDropdownLanguages.map(language => {
  return {
    name: language.toUpperCase(),
    labelKey: translationKeys.languages[language],
    code: language,
    combinedCode: normalizeToCombinedCode(language),
  };
});
